export function useFlightType({ dispatch, value, initValue }) {
  const onChange = (selectedType) => {
    dispatch({ type: 'FLIGHT_TYPE_CHANGE', payload: selectedType.value });
  };

  return { value, defaultValue: initValue, onChange, isChanged: initValue !== value };
}
